import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { SvgMatType } from "src/app/constants/icons";
import { MaskType } from "src/app/constants/masks";
import { TableColumnType } from "src/app/constants/table";
import { DependentGridList } from "src/app/models/dependent-grid";
import { CheckoutDependent, CheckoutDependents, CheckoutDependentsPayload, CheckoutMemberSSN } from "src/app/models/enrollment-checkout";
import { TableColumn } from "src/app/models/table";
import { EnrollmentCheckoutService } from "src/app/services/enrollment-checkout.service";
import { FormValidationService } from "src/app/services/form-validation.service";
import { HelperService } from "src/app/services/helper.service";
import { MaskService } from "src/app/services/mask.service";
import { SessionService } from "src/app/services/storage/session.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-ssn',
    templateUrl: './ssn.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutSSNComponent implements OnInit {
    @Input() public checkoutDependents: CheckoutDependents;
    
    @Output() public emitComplete: EventEmitter<CheckoutDependentsPayload> = new EventEmitter();

    public maskType = MaskType;
    public displayMemberSSNForm: boolean;
    public memberName: string;
    public memberFrom: FormGroup

    public spouseSSNRequiredMessage: boolean;
    public dependentForm: FormGroup
    public depedentMatTableData: MatTableDataSource<DependentGridList>;
    public depedentFormArrayName = 'depedentFormArrayName';
    public depedentTableColumns: TableColumn[] = [ 
        {
            columnName: 'Name',
            propertyId: 'dependentName',
            columnType: TableColumnType.labelAndToolTip,
            svgCustomName: SvgMatType.SmsFailed,
            toolTip: 'disabledMessage',
            toolTipCSS: 'error',
            toolTipDisplayEnd: true,
        },
        {
            columnName: 'Relationship',
            propertyId: 'dependentRelationship',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'SSN',
            propertyId: 'sSN',
            columnType: TableColumnType.input,
            maskType: MaskType.social,
            width: '20%',
        }

    ];

    constructor(
        private sessionService: SessionService,
        private formBuilder: FormBuilder,
        private enrollmentCheckoutService: EnrollmentCheckoutService,
        private helperService: HelperService,
        private maskService: MaskService,
    ) {
    }

    ngOnInit(): void {
        // Need to validate the member SSN first before moving on
        this.displayMemberSSNForm = this.checkoutDependents.requiredMemberSSN;
        this.memberName = this.sessionService.session.member.memberName;

        this.memberFrom = this.formBuilder.group({
            sSN: [null, [Validators.required, Validators.compose([FormValidationService.validSSN(true)])]]
        });

        let l_FormArray: FormArray = new FormArray([]);
        this.checkoutDependents.dependents.forEach((dependent: DependentGridList) => {
            if (dependent.spouseSSNRequired)
                this.spouseSSNRequiredMessage = true;

            l_FormArray.push(
                this.formBuilder.group({
                    dependentID: [dependent.dependentID],
                    dependentName: [dependent.dependentName],
                    dependentRelationship: [dependent.dependentRelationship],
                    sSN: [dependent.dependentSsn, dependent.spouseSSNRequired ? [Validators.required, Validators.compose([FormValidationService.validSSN(true)])] : null],
                })
            );
        });

        this.depedentMatTableData = new MatTableDataSource<DependentGridList>();
        this.depedentMatTableData.data = this.checkoutDependents.dependents;

        this.dependentForm = this.formBuilder.group({
            [this.depedentFormArrayName]: l_FormArray,
        });
    }

    public saveMemberSSN(): void {
        const l_CheckoutMemberSSN = new CheckoutMemberSSN();
        l_CheckoutMemberSSN.sSN = this.memberFrom.get('sSN').value;

        this.enrollmentCheckoutService.submitMemberSSN(l_CheckoutMemberSSN).subscribe(() => {
            this.displayMemberSSNForm = false;
        });
    }

    public complete(): void {
        const l_CheckoutDependentsPayload = new CheckoutDependentsPayload();

        const l_Array = this.dependentForm.get(this.depedentFormArrayName) as FormArray
        l_Array.controls.forEach(element => {
            const l_CheckoutDependent: CheckoutDependent = this.helperService.convertFormGroupIntoObject(element as FormGroup, new CheckoutDependent());
            l_CheckoutDependent.sSN = this.maskService.removeSSNMask(l_CheckoutDependent.sSN);
            l_CheckoutDependentsPayload.checkoutDependents.push(l_CheckoutDependent);
        });

        this.emitComplete.emit(l_CheckoutDependentsPayload);
    }
}